import { Card, CardBody, Col, Container, Image, Row } from "react-bootstrap";
import { BiSolidQuoteLeft } from "react-icons/bi";
import { SwiperSlide, Swiper } from "swiper/react";
import { primaryColor, textLightColor } from "../../../../Constants/Colors";
import { StarFill } from "react-bootstrap-icons";
import { testimonials } from "../../../../Constants/content";
import { Autoplay } from "swiper/modules";

const Testimonial = () => {
  return (
    <Container>
      <div className="d-flex align-items-center mb-2">
        <small className="text-muted text-uppercase me-3">Testimonial</small>
        <div style={{ flex: 1, height: "2px", backgroundColor: "#ccc" }}></div>
      </div>
      <Row>
        <Col lg={6}> <h1 style={{color:primaryColor}}>What Our Clients Say About Partnering With Ideal</h1></Col>
        <Col lg={12}><p>Real experiences. Real results.</p></Col>
      </Row>

      <Swiper
        watchSlidesProgress={true}
        centeredSlides={true}
        loop={true}
        spaceBetween={10}
        modules={[Autoplay]}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        breakpoints={{
          0: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 3,
          },
        }}
        className="mySwiper testimonial-swiper py-5"
      >
        {testimonials.map((testimonial, index) => {
          return (
            <SwiperSlide key={index}>
              <Card
                style={{
                  border: "none",
                  backgroundColor: primaryColor,
                  color: textLightColor,
                  cursor: "pointer",
                }}
                className="overflow-hidden"
              >
                <CardBody>
                  <BiSolidQuoteLeft
                    className="slider-quote"
                    color={textLightColor}
                  />
                  <p style={{ fontSize: "14px" }} className="testimonial-desc text-justify">
                    {testimonial.description}
                  </p>
                  <Row className="align-items-center d-flex">
                    <Col xs={3} lg={2}>
                      <Image
                        src={testimonial.image}
                        roundedCircle
                        className="testimonial-profilepic"
                        alt="Profile Picture"
                      ></Image>
                    </Col>
                    <Col xs={5} lg={6} className="testimonial-name ">
                      <h6>{testimonial.name}</h6>
                      <p className="d-block mb-0" style={{ fontSize: "12px" }}>
                        {testimonial.designation}
                      </p>
                    </Col>
                    <Col xs={4} className="d-flex align-items-center">
                      <div className="bg-light align-items-center d-flex p-1 p-lg-2 rounded-pill">
                        {[...Array(testimonial.rating)].map((_, i) => (
                          <StarFill
                            key={i}
                            color="gold"
                            className="me-xl-1 star-rating"
                          />
                        ))}
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </Container>
  );
};

export default Testimonial;
